import $ from 'jquery'
import {algoliasearch} from 'algoliasearch'
import instantsearch from 'instantsearch.js'
import {
    menu,
    sortBy,
    configure,
    clearRefinements,
    menuSelect,
    refinementList,
} from 'instantsearch.js/es/widgets'
import {history} from 'instantsearch.js/es/lib/routers'
import {
    connectSearchBox,
    connectCurrentRefinements,
} from 'instantsearch.js/es/connectors'
import {connectStats} from 'instantsearch.js/es/connectors';
import {connectHits} from 'instantsearch.js/es/connectors'
import {connectPagination} from 'instantsearch.js/es/connectors'
import {algoliaAppId, algoliaApiKey} from '../variables'
import {productHit, noResult, shopPagination} from '../templates'
import {dynamicUriTemplate, extractParamsFromUri} from '../functions'

// eslint-disable-next-line no-undef
const {__, _n, sprintf} = wp.i18n

// eslint-disable-next-line no-undef
const object = vnObject

const {
    query,
    product_cat,
    product_collection,
    glasses_frame_color,
    glasses_type,
    glasses_size,
    glasses_material,
    glasses_shape,
    product_tag,
    product_kind,
    pro_product_tag,
    pa_glass_color,
} = object.algoliaQueryStrings
// Chemin complet de la page boutique (préfixe de langue WPML et pages parentes compris).
var productsMainSlug = $('.js-custom-shop-link').data('url')

const slugs = {
    query,
    product_cat,
    product_collection,
    glasses_frame_color,
    glasses_type,
    glasses_size,
    glasses_material,
    glasses_shape,
    product_tag,
    product_kind,
    pro_product_tag,
    pa_glass_color,
};

// Chaque filtre de la page doit avoir son slug d'URL, y compris les attributs pa_* autres
// que pa_glass_color (même règle qu'en PHP : permalien de la taxonomie, sinon son nom).
(object.customShopFilters || []).forEach((filter) => {
    const shortAttribute = filter.attribute.split('.').pop()
    if (!slugs[shortAttribute]) {
        slugs[shortAttribute] = object.algoliaQueryStrings[shortAttribute] || shortAttribute
    }
})

// Attribut Algolia d'un filtre, identique pour les widgets et le routing :
// les attributs WooCommerce (pa_*) sont indexés sous productAttributes.
const facetAttribute = (attribute) =>
    (attribute.startsWith('pa_') ? 'productAttributes.' + attribute : attribute) + '.name'

var priceIndexAsc = object.isPro ? object.currentLanguageCode + '_product_pro_price_asc' : object.currentLanguageCode + '_product_price_asc';
var priceIndexDesc = object.isPro ? object.currentLanguageCode + '_product_pro_price_desc' : object.currentLanguageCode + '_product_price_desc';
// Nouveautés puis prix croissant : disponible une fois `wp vn algolia-date-sort` lancé (voir vn_get_algolia_shop_default_index()).
var dateIndex = object.isPro ? object.currentLanguageCode + '_product_pro_date_desc' : object.currentLanguageCode + '_product_date_desc';
var defaultIndex = object.algoliaDateSort ? dateIndex : priceIndexAsc;
let productsSearch
const checkEl = document.querySelector('.pt-custom-shop__hits')
if (checkEl) {
    const searchClient = algoliasearch(algoliaAppId, algoliaApiKey)
    productsSearch = instantsearch({
        indexName: defaultIndex,
        searchClient,
        insights: true,
        clickAnalytics: true,
        routing: {
            router: history({
                cleanUrlOnDispose: false,

                createURL({location, routeState}) {
                    const params = {
                        query: routeState.query,
                        glasses_type: routeState.glasses_type,
                    };

                    // ajoute chaque filtre présent dans le routeState
                    (object.customShopFilters || []).forEach(filter => {
                        const key = filter.attribute;        // clé de route (on garde l'attribut tel quel)
                        const shortAttribute = key.split('.').pop();
                        const val = routeState[shortAttribute];
                        if (val != null && val !== '' && !(Array.isArray(val) && val.length === 0)) {
                            params[shortAttribute] = val;                 // string ou array selon le widget
                        }
                    });

                    // Pagination : /{page}/[{filtres}/]page/{n}/, même format que les liens rendus en PHP
                    // (inc/Algolia/shop-pagination.php). La page 1 n'a pas de segment.
                    const url = dynamicUriTemplate(location.origin, params, productsMainSlug, slugs);
                    const page = parseInt(routeState.page, 10);

                    return page > 1 ? `${url}page/${page}/` : url;
                },

                parseURL({location}) {
                    const params = extractParamsFromUri(location.href, slugs);
                    const route = {
                        query: params[slugs.query] && params[slugs.query][0],
                        glasses_type: params[slugs.glasses_type] && params[slugs.glasses_type][0],
                    };

                    const pageMatch = location.pathname.match(/\/page\/(\d+)\/?$/);
                    if (pageMatch && parseInt(pageMatch[1], 10) > 1) {
                        route.page = parseInt(pageMatch[1], 10);
                    }

                    // reconstitue le routeState depuis l’URL
                    (object.customShopFilters || []).forEach(filter => {
                        const key = filter.attribute;
                        const shortAttribute = key.split('.').pop();
                        const slugKey = slugs[shortAttribute];    // ex: "placeCategory"
                        if (params[slugKey] !== undefined) {
                            route[shortAttribute] = params[slugKey];      // string | array (InstantSearch gère les deux)
                        }
                    });

                    return route;
                },
            }),

            stateMapping: {
                stateToRoute(uiState) {
                    const indexUiState = uiState[defaultIndex] || uiState[priceIndexAsc] || uiState[priceIndexDesc] || {};
                    const res = {
                        query: indexUiState.query,
                        glasses_type: indexUiState.menu?.['glasses_type.name'],
                        page: indexUiState.page,
                    };

                    (object.customShopFilters || []).forEach(filter => {
                        const attr = filter.attribute;
                        const shortAttribute = attr.split('.').pop();
                        const type = filter.widget;
                        if (type === 'menu' || type === 'menuSelect') {
                            res[shortAttribute] = indexUiState.menu?.[facetAttribute(attr)] || undefined;
                        } else if (type === 'refinementList') {
                            res[shortAttribute] = indexUiState.refinementList?.[facetAttribute(attr)] || undefined;
                        }
                    });

                    return res;
                },

                routeToState(routeState) {
                    const menu = {
                        'glasses_type.name': routeState.glasses_type,
                    };
                    const refinementList = {};

                    (object.customShopFilters || []).forEach(filter => {

                        const attr = filter.attribute;
                        const shortAttribute = attr.split('.').pop();
                        const type = filter.widget;
                        const val = routeState[shortAttribute];

                        if (val === undefined) return;

                        if (type === 'menu' || type === 'menuSelect') {
                            // menu/menuSelect = valeur simple
                            menu[facetAttribute(attr)] = Array.isArray(val) ? val[0] : val;
                        } else if (type === 'refinementList') {
                            // refinementList = tableau
                            refinementList[facetAttribute(attr)] = Array.isArray(val) ? val : [val];
                        }
                    });

                    return {
                        [defaultIndex]: {
                            query: routeState.query,
                            menu,
                            refinementList,
                            page: routeState.page,
                        },
                    };
                },
            },
        },
    });

    const productItem = ({hits, sendEvent, widgetParams}) => {
        const container = document.querySelector(widgetParams.container)
        container.innerHTML = `
      ${
            hits.length
                ? hits
                    .map((item) => {
                        return productHit(item, 'g-col-6 g-col-md-4 js-product-hit-col')
                    })
                    .join('')
                : noResult
        }
  `

        container
            .querySelectorAll('.feed-product__wrapper')
            .forEach((element, index) => {
                element.addEventListener('click', (event) => {
                    sendEvent('click', hits[index], 'Product Clicked')
                })
            })
    }

    const productItems = connectHits(productItem)

    // Remplace la pagination rendue en PHP par le même markup (shopPagination). Les liens
    // gardent leur vraie URL : clic molette / ctrl+clic ouvrent la page, un clic simple
    // passe par InstantSearch sans rechargement.
    let refinePage = () => {}

    const renderPagination = ({currentRefinement, nbPages, refine, createURL, widgetParams}, isFirstRender) => {
        const container = document.querySelector(widgetParams.container)

        if (!container) {
            return
        }

        refinePage = refine

        if (isFirstRender) {
            container.addEventListener('click', (event) => {
                const link = event.target.closest('[data-page]')

                if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
                    return
                }

                event.preventDefault()
                refinePage(parseInt(link.dataset.page, 10) - 1)
                $('html, body').animate({scrollTop: 0}, 'fast')
            })

            // Pas encore de résultats au premier rendu : on garde le HTML serveur.
            return
        }

        container.innerHTML = shopPagination(currentRefinement + 1, nbPages, (page) => createURL(page - 1))
    }

    const customPagination = connectPagination(renderPagination)

    const renderSearchBox = (renderOptions, isFirstRender) => {
        const {query, refine, clear, isSearchStalled, widgetParams} =
            renderOptions
        const container = document.querySelector(widgetParams.container)

        if (isFirstRender) {
            const input = document.createElement('input')
            input.type = 'search'
            input.placeholder = widgetParams.placeholder

            container.insertAdjacentHTML('beforeend', object.loader)

            const reset = document.createElement('button')
            reset.type = 'reset'
            reset.insertAdjacentHTML('beforeend', '<i class="vn-icons-close"></i>')

            const submit = document.createElement('button')
            submit.type = 'submit'
            submit.insertAdjacentHTML('beforeend', '<i class="vn-icons-search"></i>')

            input.addEventListener('input', (product) => {
                refine(product.target.value)
            })

            reset.addEventListener('click', () => {
                clear()
            })

            container.appendChild(input)
            container.appendChild(reset)
            container.appendChild(submit)
        }

        container.querySelector('input').value = query
        container.querySelector('.vn-loader').hidden = !isSearchStalled
        container.querySelector('button[type="reset"]').hidden =
            isSearchStalled || !query
        container.querySelector('button[type="submit"]').hidden = isSearchStalled
    }

    const customSearchBox = connectSearchBox(renderSearchBox)

    const renderCurrentRefinements = ({items, widgetParams}) => {
        const container = document.querySelector(widgetParams.container)
        const totalItemCount = items.reduce(
            (acc, curr) => acc + curr.refinements.length,
            0
        )

        container.innerHTML = sprintf(
            _n('%s active filter', '%s active filters', totalItemCount, 'vn'),
            totalItemCount
        )
    }

    const customCurrentRefinements = connectCurrentRefinements(
        renderCurrentRefinements
    )

    const renderStats = (renderOptions, isFirstRender) => {
        const {nbHits} = renderOptions;

        document.querySelectorAll('.js-number-result').forEach(element => {
            element.innerHTML = `
            (${nbHits})
          `;
        });
    };

    const customStats = connectStats(
        renderStats
    );

    var excludeProProducts = object.isPro ? '' : 'no';

    if (productsSearch) {

        productsSearch.addWidgets([
            customSearchBox({
                container: '.pt-custom-shop__search-handler',
                placeholder: __('Search...', 'vn'),
                showLoadingIndicator: false,
            }),

            clearRefinements({
                container: '.pt-custom-shop__reset-handler',
                templates: {
                    resetLabel({hasRefinements}, {html}) {
                        return html`
                            <div class="vn-btn vn-btn--link">
                                ${hasRefinements
                                        ? __('Reset filters', 'vn')
                                        : __('No filters', 'vn')}
                            </div>`
                    },
                },
            }),

            sortBy({
                container: '.pt-custom-shop__sortby-handler',
                items: [
                    ...(object.algoliaDateSort ? [{label: __('Sort by newest', 'vn'), value: dateIndex}] : []),
                    {label: __('Sort by ascending price', 'vn'), value: priceIndexAsc},
                    {label: __('Sort by descending  price', 'vn'), value: priceIndexDesc},
                ],
            }),

            customCurrentRefinements({
                container: '.pt-custom-shop__stats-handler',
            }),

            menu({
                container: '.pt-custom-shop__glasses-type-handler',
                attribute: 'glasses_type.name',
                limit: 99,
                sortBy: ['name:desc'],
            }),

            productItems({
                container: '.pt-custom-shop__hits',
            }),

            customPagination({
                container: '.pt-custom-shop__pagination-handler',
            }),

            configure({
                hitsPerPage: object.shopHitsPerPage,
                facetFilters: [
                    'product_kind.objectID:' + object.shopProductKind,
                    'productIsPro:' + excludeProProducts,
                ],
            }),

            customStats({}),
        ])

        if (typeof object.customShopFilters !== 'undefined') {
            const dynamicWidgets = [];
            object.customShopFilters.forEach((filter => {
                var attribute = filter.attribute
                var widget = filter.widget
                const shortAttribute = attribute.split('.').pop();
                const container = `.filter-${shortAttribute}`;
                switch (widget) {
                    case 'refinementList':
                        dynamicWidgets.push(
                            refinementList({
                                container: container,
                                limit: 99,
                                attribute: facetAttribute(attribute),
                                templates: {
                                    item: (item) => {
                                        const termField = object.termFields[item.label.toLowerCase()];

                                        let style = "";
                                        if (termField && (termField.color.length > 0 || termField.icon.length > 0)) {
                                            style = `background:${termField.icon ? `url(${termField.icon})` : termField.color}`
                                        }
                                        return `<span class="color-swatch" style="${style}"></span> ${item.label}`
                                    }
                                },
                            }),
                        );
                        break;

                    case 'menu':
                        dynamicWidgets.push(
                            menu({
                                container: container,
                                attribute: facetAttribute(attribute),
                                limit: 99,
                                templates: {
                                    item(data, {html}) {
                                        const {label, count, url, cssClasses} = data;
                                        var icon = ''
                                        if (filter.type === 'button_picto') {
                                            icon = object.termFields[label.toLowerCase()]
                                            if (typeof icon !== 'undefined' && icon !== '') {
                                                return html`
                                                    <a class="${cssClasses.link}" href="${url}">
                                                        <img class="button-icon" src="${icon.icon ? icon.icon : ''}"></img>
                                                        <span class="${cssClasses.label}">${label}</span>
                                                    </a>
                                                `;
                                            }
                                        }

                                        return html`
                                            <a class="${cssClasses.link}" href="${url}">
                                                <span class="${cssClasses.label}">${label}</span>
                                            </a>
                                        `;
                                    },
                                },
                            }),
                        );
                        break;

                    case 'menuSelect':
                        const defaultOption = filter.default
                        dynamicWidgets.push(
                            menuSelect({
                                container: container,
                                limit: 99,
                                attribute: facetAttribute(attribute),
                                templates: {
                                    item(item, {html}) {
                                        return html`<span>${item.label}</span>`;
                                    },
                                    defaultOption(data, {html}) {
                                        return html`<span>${defaultOption}</span>`;
                                    },
                                },
                            }),
                        );
                        break;
                }
            }));

            if (dynamicWidgets.length > 0) {
                productsSearch.addWidgets(dynamicWidgets);
            }
        }

        productsSearch.start()
    }
}

export {productsSearch}

$('#filtersOffcanvas').on('hidden.bs.offcanvas', function () {
    $('html, body').animate({scrollTop: 0}, 'fast');
});

function initQtyButtons(scope = document) {
    scope.querySelectorAll(".quantity").forEach(function (el) {
        // éviter de recréer des boutons déjà existants
        if (el.querySelector(".qty-btn")) return;

        let input = el.querySelector(".qty");

        if (!input || input.type === "hidden" || input.style.display === "none") {
            el.classList.add("hidden");
            return;
        }

        let btnMinus = document.createElement("button");
        let btnPlus = document.createElement("button");
        btnMinus.innerHTML = "−";
        btnPlus.innerHTML = "+";
        btnMinus.className = "qty-btn minus";
        btnPlus.className = "qty-btn plus";
        btnMinus.type = "button";
        btnPlus.type = "button";

        el.insertBefore(btnMinus, input);
        el.appendChild(btnPlus);

        btnMinus.addEventListener("click", () => {
            if (input.value > 1) input.value--;
            triggerChange(input);
        });
        btnPlus.addEventListener("click", () => {
            input.value++;
            triggerChange(input);
        });
    });
}

function triggerChange(el) {
    el.dispatchEvent(new Event("change", {bubbles: true}));
}

// 🔥 initialisation au chargement
window.addEventListener("load", function () {
    initQtyButtons();

    // 🔄 Réappliquer après mise à jour AJAX du panier
    jQuery(document.body).on("updated_cart_totals", function () {
        initQtyButtons(document);
    });
});

jQuery(document.body).on("wc_fragment_refresh updated_wc_div", function () {
    initQtyButtons(document);
});
